/**
 * !!! Do not edit this file directly !!!
 * This file was generated by @blueshift-ui/analytics
 * To edit these event names, update the tracking plan in Segment and run the generate-event-types command again.
 *
 * @see https://github.com/varsitytutors/blueshift-ui/blob/master/packages/analytics/README.md#types-generation
 */

/* eslint-disable */

const ANALYTICS_EVENT_NAMES = {
  contactInformationUpdated: 'Contact Information Updated',
  contentViewed: 'Content Viewed',
  elementClicked: 'Element Clicked',
  elementClosed: 'Element Closed',
  elementHovered: 'Element Hovered',
  elementOpened: 'Element Opened',
  errorLogged: 'Error Logged',
  featureFlagEvaluated: 'Feature Flag Evaluated',
  initializeAmplitudeSession: 'Initialize Amplitude Session',
  pageViewed: 'Page Viewed',
  passwordResetRequested: 'Password Reset Requested',
  passwordUpdated: 'Password Updated',
  paymentMethodAdded: 'Payment Method Added',
  screenViewed: 'Screen Viewed',
  sessionRecordingPreferencesUpdated: 'Session Recording Preferences Updated',
  setAmplitudeSessionId: 'Set Amplitude Session ID',
  subscriptionCanceled: 'Subscription Canceled',
  userEnteredInput: 'User Entered Input',
  userSignedIn: 'User Signed In',
};

export default ANALYTICS_EVENT_NAMES;
